import { render } from "./MCheckout.vue?vue&type=template&id=08939134&ts=true"
import script from "./MCheckout.vue?vue&type=script&lang=ts"
export * from "./MCheckout.vue?vue&type=script&lang=ts"

import "./MCheckout.vue?vue&type=style&index=0&id=08939134&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__